/**
 * TikTok glyph.
 *
 * lucide-react ships no TikTok icon, and TikTok is the only social profile
 * EC Design and Construction currently has, so the mark is inlined here and
 * shared by the top bar and the footer.
 */
const TikTokIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 1 1 .77-5.06V9.66a5.67 5.67 0 0 0-.77-.05A5.66 5.66 0 1 0 15.54 15V8.99a7.35 7.35 0 0 0 4.3 1.38V7.28a4.29 4.29 0 0 1-3.24-1.46Z" />
  </svg>
);

export default TikTokIcon;
